import { useEffect } from "react";
import { useLang } from "../LangContext";
import { useSupabaseAuth } from "../SupabaseAuthContext";

/**
 * Applica preferred_language dal profilo Supabase SOLO se l'utente ha già
 * scelto esplicitamente una lingua (altrimenti resta il default italiano).
 */
export default function LangSupabaseSync() {
  const { profile } = useSupabaseAuth();
  const { setLang } = useLang();

  useEffect(() => {
    let explicit = false;
    try {
      explicit = localStorage.getItem("6amico_lang_explicit") === "1";
    } catch {
      explicit = false;
    }
    if (!explicit) return;

    const pl = profile?.preferred_language;
    if (!pl || typeof pl !== "string") return;
    const code = pl.split("-")[0].toLowerCase();
    if (code) setLang(code);
  }, [profile?.preferred_language, setLang]);

  return null;
}
